<template>
  <div class="d-flex flex-column align-items-center wrapper_error">
    <div class="d-flex flex-row">
      <div class="d-flex title">
        {{ title }}
      </div>
    </div>
    <!-- <div class="body">{{ $t(`error.${errorData.name}.body`) }}</div> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {}
  },
  props: {
    errorData: {
      type: Object,
      default: () => {
        return {
          name: 'notFound',
        }
      },
    },
  },
  computed: {
    ...mapGetters('limits', { limitDaily: 'daily' }),
    // Виджеты не передают причину ошибки, поэтому если в этой сессии бэкенд уже
    // ответил 429 (лимит доменов), пишем про лимит, а не «нет данных»
    errorName() {
      if (this.errorData.name === 'notFound' && this.limitDaily) return 'limitExceeded'
      return this.errorData.name
    },
    title() {
      const key = `error.${this.errorName}`
      return this.$te(`${key}.title`) ? this.$t(`${key}.title`) : this.$t(key)
    },
  },
  methods: {},
}
</script>

<style scoped>
.wrapper_error {
  padding: 0 20px;
  margin: 10px 0;
}
.title {
  color: var(--text-secondary3);
  margin-right: 5px;
  text-align: center;
}
.body {
  color: var(--text-secondary3);
  text-align: center;
}
.image_error {
  width: 125px;
  margin-bottom: 15px;
}
.specialTitleText {
  color: var(--main-color);
  font-weight: 400;
}
</style>
